module.exports = __webpack_public_path__ + "static/img/289_TO8_2456.5c93e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/289_TO8_2456.jpg
// module id = 2WHe
// module chunks = 0